import {SelectOption} from "../../tools/select/select.component";
import {getAllUnsupportedLanguages} from "./get-all-unsupported-languages";
import {environment} from "../../../environments/environment";
import {languageFlag} from "../../tools/language-flag";

export function buildNewLanguageOptions(): SelectOption[] {
  return getAllUnsupportedLanguages()
    .map(languageCode => ({
      code: languageCode,
      flag: languageFlag(languageCode),
      name: languageDisplayName(languageCode),
    }))
    .sort((first, second) => first.name.localeCompare(second.name))
    .map(language => ({
      value: language.code,
      text: `${language.flag} ${language.name}`,
      localize: false,
    }));
}

function languageDisplayName(languageCode: string): string {
  return new Intl.DisplayNames([environment.language], {type: "language", languageDisplay: "standard"})
    .of(languageCode)!;
}
